var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"text-2xl mb-6"},[_vm._v("Arbitrage Daily Report")]),_c('DailyReportFilters',{ref:"dailyReportFilters"}),_c('totals'),_c('DailyReportTable',{ref:"dailyReportTable"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }